/**
 * Battle Frontier: facility info for the right-panel hub —
 * GENERATED by client/setup_client.py from data/bf-facilities.json
 * and data/bf-sample-teams.json. Consumed by the BF-HUB-PANEL
 * patch in panel-rooms.tsx. Do not edit; re-run the setup script.
 */

export interface BFFacilityInfo {
	id: string, name: string, game: string, gen: number,
	formats: string[], tagline?: string, rules?: string[],
	mechanics?: string[], landmarks?: string[],
	resources?: { label: string, url: string }[],
}

export const BFFacilities: BFFacilityInfo[] = [
 {
  "id": "eba",
  "name": "EBA",
  "game": "Scarlet/Violet",
  "gen": 9,
  "formats": [
   "gen9ebasingles",
   "gen9ebadoubles",
   "gen9ebadoubles6v6"
  ],
  "tagline": "",
  "rules": [
   "Bring exactly 3 Pokémon (singles), 4 (doubles) or 6 (doubles 6v6)",
   "Level 50: every Pokémon plays at 50, whether it is above or below",
   "Species clause: no duplicate Pokémon",
   "Item clause: no duplicate held items",
   "Team lock: You may not switch teams once a streak is ongoing",
   "Terastallization is legal, for you and for the opponent",
   "Most restricted legendaries (Mewtwo, Zacian, etc.) are banned, plus Magearna. Regular Kyurem, Zygarde and Necrozma formes are allowed."
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   ""
  ]
 },
 {
  "id": "tower8",
  "name": "Battle Tower",
  "game": "Pokémon Sword/Shield",
  "gen": 8,
  "formats": [
   "gen8battletowersingles",
   "gen8battletowerdoubles"
  ],
  "tagline": "",
  "rules": [
   "Bring exactly 3 Pokémon (singles) or 4 (doubles)",
   "Level 50: Pokémon above Lv. 50 play at 50",
   "Species clause: no duplicate Pokémon",
   "Item clause: no duplicate held items",
   "Team lock: You may not switch teams once a streak is ongoing",
   "Classic ruleset: You may not Dynamax. The AI sometimes does (Dmax Level: 0).",
   "Most restricted legendaries (Mewtwo, Zacian, etc.) are banned. Regular Kyurem, Zygarde and Necrozma formes are allowed.",
   "Mythicals are allowed, except for Magearna and Melmetal"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "Master Ball tier only, difficulty is consistent throughout",
   "Most opponents have imperfect IVs",
   "Every 10th battle: Champion Leon with G-Max Charizard",
   "9 other trainers can Dynamax against you",
   "Rather than re-roll, the AI avoids breaking item clause by replacing with the following items, respectively: Sitrus Berry, Focus Sash, Lum Berry, Quick Claw"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "sparring8",
  "name": "Restricted Sparring",
  "game": "Pokémon Sword/Shield: Isle of Armor",
  "gen": 8,
  "formats": [
   "gen8restrictedsparring"
  ],
  "tagline": "",
  "rules": [
   "Bring exactly 3 Pokémon sharing one type",
   "A dual-type counts for either of its types",
   "Level 50: Pokémon above Lv. 50 play at 50",
   "Species clause: no duplicate Pokémon",
   "Item clause: no duplicate held items",
   "Team lock: You may not switch teams once a streak is ongoing",
   "Standard banlist: no restricted legendaries or mythicals",
   "You may Dynamax once per battle"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "Monotype challenge with no automatic healing",
   "2 full team restores per run, available between battles",
   "A double knockout ending the battle counts as a loss",
   "18 per-type leaderboards + an overall leaderboard"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "towerbdsp",
  "name": "BDSP Battle Tower",
  "game": "Pokémon Brilliant Diamond/Shining Pearl",
  "gen": 8,
  "formats": [
   "gen8bdspbattletowersingles",
   "gen8bdspbattletowerdoubles"
  ],
  "tagline": "",
  "rules": [
   ""
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   ""
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "eisentree2",
  "name": "EisenTree",
  "game": "Ultra Sun/Ultra Moon (modded)",
  "gen": 7,
  "formats": [
   "gen7eisentree2singles",
   "gen7eisentree2doubles",
   "gen7eisentree2doubles6v6"
  ],
  "tagline": "",
  "rules": [
   "Bring exactly 3 Pokémon (singles), 4 (doubles) or 6 (doubles 6v6)",
   "Level 50: every Pokémon plays at 50, whether it is above or below",
   "Species clause: no duplicate Pokémon",
   "Item clause: no duplicate held items",
   "Team lock: You may not switch teams once a streak is ongoing",
   "Banlist: most restricted legendaries plus Magearna, mythicals are allowed"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   ""
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "tree7",
  "name": "Battle Tree",
  "game": "Pokémon Ultra Sun/Ultra Moon",
  "gen": 7,
  "formats": [
   "gen7battletreesingles",
   "gen7battletreedoubles"
  ],
  "tagline": "",
  "rules": [
   "Bring exactly 3 Pokémon (singles) or 4 (doubles)",
   "Level 50: Pokémon above Lv. 50 play at 50",
   "Species clause: no duplicate Pokémon",
   "Item clause: no duplicate held items",
   "Team lock: You may not switch teams once a streak is ongoing",
   "Standard banlist: no restricted legendaries or mythicals"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "Every 10th battle is a boss battle",
   "Features the boss trainers from both Ultra Sun and Ultra Moon",
   "Opponents use both Mega Evolution and Z-Moves"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "maison6",
  "name": "Battle Maison",
  "game": "Pokémon Omega Ruby/Alpha Sapphire",
  "gen": 6,
  "formats": [
   "gen6battlemaisonsingles",
   "gen6battlemaisondoubles",
   "gen6battlemaisontriples"
  ],
  "tagline": "",
  "rules": [
   "Bring exactly 3 (singles), 4 (doubles), or 6 (triples)",
   "Level 50: Pokémon above Lv. 50 play at 50",
   "Species clause: no duplicate Pokémon",
   "Item clause: no duplicate held items",
   "Team lock: You may not switch teams once a streak is ongoing",
   "Standard banlist: no restricted legendaries or mythicals"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "Battle 50: the format's Battle Chatelaine",
   "Nita (singles), Evelyn (doubles), Dana (triples)",
   "Opponents do not use Mega Evolution"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "subway5",
  "name": "Battle Subway",
  "game": "Pokémon Black 2/White 2",
  "gen": 5,
  "formats": [
   "gen5battlesubwaysingles",
   "gen5battlesubwaydoubles"
  ],
  "tagline": "",
  "rules": [
   "Bring exactly 3 Pokémon (singles) or 4 (doubles)",
   "Level 50: Pokémon above and below Lv. 50 play at 50",
   "Species clause: no duplicate Pokémon",
   "Item clause: no duplicate held items",
   "Team lock: You may not switch teams once a streak is ongoing",
   "Standard banlist: no restricted legendaries or mythicals"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "Battle 49: Subway Boss Ingo (singles) or Emmet (doubles)"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "tower4",
  "name": "Battle Tower",
  "game": "Pokémon Platinum",
  "gen": 4,
  "formats": [
   "gen4battletowersingles",
   "gen4battletowerdoubles"
  ],
  "tagline": "",
  "rules": [
   "Bring 3 Pokémon (4 in doubles)",
   "Level 50 or below",
   "Species clause: no duplicate Pokémon",
   "Item clause: no duplicate held items",
   "Team lock: You may not switch teams once a streak is ongoing",
   "Frontier banlist: no restricted legendaries or mythicals"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "Rounds of 7 battles",
   "Battle 21: Tower Tycoon Palmer (Silver) — singles only",
   "Battle 49: Tower Tycoon Palmer (Gold) — singles only"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "factory4",
  "name": "Battle Factory",
  "game": "Pokémon Platinum",
  "gen": 4,
  "formats": [
   "gen4battlefactorysingles",
   "gen4battlefactorydoubles",
   "gen4battlefactoryopensingles",
   "gen4battlefactoryopendoubles"
  ],
  "tagline": "",
  "rules": [
   "You bring nothing: all Pokémon are rentals",
   "Draft 3 from 6 offered at each round start",
   "Level 50 mode or Open Level (level 100) mode",
   "After each win, you may swap one rental for a foe's Pokémon"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "Rounds of 7 battles, new rental draft each round",
   "Battle 21: Factory Head Thorton (Silver) — singles only",
   "Battle 49: Factory Head Thorton (Gold) — singles only"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "hall4",
  "name": "Battle Hall",
  "game": "Pokémon Platinum",
  "gen": 4,
  "formats": [
   "gen4battlehallsingles",
   "gen4battlehalldoubles"
  ],
  "tagline": "",
  "rules": [
   "Bring ONE Pokémon (a same-species pair in doubles)",
   "Level 30 or above; opponents adjust automatically",
   "No item clause in doubles",
   "You may switch your set between rounds",
   "Frontier banlist: no restricted legendaries or mythicals",
   "Your streak is tied to the species"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "Rounds of 10 battles",
   "Battle 50: Hall Matron Argenta (Silver) — singles only",
   "Battle 170: Hall Matron Argenta (Gold) — singles only"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "castle4",
  "name": "Battle Castle",
  "game": "Pokémon Platinum",
  "gen": 4,
  "formats": [
   "gen4battlecastlesingles",
   "gen4battlecastledoubles"
  ],
  "tagline": "",
  "rules": [
   "Bring 3 Pokémon (singles and doubles)",
   "Level 50 or below",
   "Species clause: no duplicate Pokémon",
   "Held items are confiscated at the door",
   "Team lock: You may not switch teams once a streak is ongoing",
   "Frontier banlist: no restricted legendaries or mythicals"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "Rounds of 7 battles; HP/PP carry within a round",
   "Battle 21: Castle Valet Darach (Silver) — singles only",
   "Battle 49: Castle Valet Darach (Gold) — singles only"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "arcade4",
  "name": "Battle Arcade",
  "game": "Pokémon Platinum",
  "gen": 4,
  "formats": [
   "gen4battlearcadesingles",
   "gen4battlearcadedoubles"
  ],
  "tagline": "",
  "rules": [
   "Bring 3 Pokémon (singles and doubles)",
   "Level 50 or below",
   "Species clause: no duplicate Pokémon",
   "Held items are confiscated for both the player and the opponent",
   "Team lock: You may not switch teams once a streak is ongoing",
   "Frontier banlist: no restricted legendaries or mythicals"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "Rounds of 7 battles; board speeds up in later rounds",
   "Battle 21: Arcade Star Dahlia (Silver) — singles only",
   "Battle 49: Arcade Star Dahlia (Gold) — singles only"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "tower3",
  "name": "Battle Tower",
  "game": "Pokémon Emerald",
  "gen": 3,
  "formats": [
   "gen3battletowersingles",
   "gen3battletowerdoubles",
   "gen3battletoweropensingles",
   "gen3battletoweropendoubles"
  ],
  "tagline": "",
  "rules": [
   "Bring 3 Pokémon (singles) or 4 (doubles)",
   "Level cap 50; Open Level allows up to 100",
   "Species clause: no duplicate Pokémon",
   "Item clause: no duplicate held items",
   "Team lock: You may not switch teams once a streak is ongoing",
   "Frontier banlist: no restricted legendaries or mythicals"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "Battles grouped in sets of 7",
   "Salon Maiden Anabel at battle 35 (Silver) — singles only",
   "Anabel again at battle 70 (Gold), then every 35 battles"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "factory3",
  "name": "Battle Factory",
  "game": "Pokémon Emerald",
  "gen": 3,
  "formats": [
   "gen3battlefactorysingles",
   "gen3battlefactorydoubles",
   "gen3battlefactoryopensingles",
   "gen3battlefactoryopendoubles"
  ],
  "tagline": "",
  "rules": [
   "You bring nothing: all Pokémon are rentals",
   "Teams are always 3 Pokémon, even in doubles",
   "No two rentals of the same species",
   "Level 50, or flat level 100 in Open Level",
   "After each win you may trade one Pokémon for a beaten one"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "Rounds of 7 battles; fresh draft each round",
   "Battles 1–14: opponents pick moves at random",
   "Battles 15–28: opponents avoid bad moves",
   "Battle 29+: full AI",
   "Factory Head Noland at battles 21 and 42, then every 21, using random teams"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "palace3",
  "name": "Battle Palace",
  "game": "Pokémon Emerald",
  "gen": 3,
  "formats": [
   "gen3battlepalacesingles",
   "gen3battlepalacedoubles",
   "gen3battlepalaceopensingles",
   "gen3battlepalaceopendoubles"
  ],
  "tagline": "",
  "rules": [
   "Bring 3 Pokémon (singles) or 4 (doubles)",
   "Level cap 50; Open Level allows up to 100",
   "Species clause: no duplicate Pokémon",
   "Item clause: no duplicate held items",
   "Team lock: You may not switch teams once a streak is ongoing",
   "Frontier banlist: no restricted legendaries or mythicals"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "Pokémon pick their moves based on their nature",
   "Battles grouped in sets of 7",
   "Palace Maven Spenser at battle 21 (Silver) — singles only",
   "Spenser again at battle 42 (Gold), then every 21 battles"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "arena3",
  "name": "Battle Arena",
  "game": "Pokémon Emerald",
  "gen": 3,
  "formats": [
   "gen3battlearenasingles",
   "gen3battlearenaopensingles"
  ],
  "tagline": "",
  "rules": [
   "Bring 3 Pokémon",
   "Level cap 50; Open Level allows up to 100",
   "Species clause: no duplicate Pokémon",
   "Item clause: no duplicate held items",
   "Team lock: You may not switch teams once a streak is ongoing",
   "Frontier banlist: no restricted legendaries or mythicals",
   "Switching is not allowed",
   "Roar, Whirlwind, and Baton Pass always fail"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "1v1s last maximum 3 turns before going to judge",
   "Battles grouped in sets of 7",
   "Arena Tycoon Greta at battle 28 (Silver)",
   "Greta again at battle 56 (Gold), then every 28 battles"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "dome3",
  "name": "Battle Dome",
  "game": "Pokémon Emerald",
  "gen": 3,
  "formats": [
   "gen3battledomesingles",
   "gen3battledomedoubles",
   "gen3battledomeopensingles",
   "gen3battledomeopendoubles"
  ],
  "tagline": "",
  "rules": [
   "Register 3 Pokémon; pick 2 of them each round",
   "Level cap 50; Open Level allows up to 100",
   "Species clause: no duplicate Pokémon",
   "Item clause: no duplicate held items",
   "Team lock: You may not switch teams once a streak is ongoing",
   "Frontier banlist: no restricted legendaries or mythicals"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "4 rounds per tournament",
   "Dome Ace Tucker in tournament 4 (Silver) — singles only",
   "Tucker again in tournament 9 (Gold), then every 5",
   "Tucker is always seeded on the opposite half to set up the finals"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 },
 {
  "id": "pike3",
  "name": "Battle Pike",
  "game": "Pokémon Emerald",
  "gen": 3,
  "formats": [
   "gen3battlepike",
   "gen3battlepikeopenlevel"
  ],
  "tagline": "",
  "rules": [
   "Bring 3 Pokémon",
   "Level cap 50; Open Level allows up to 100",
   "Species clause: no duplicate Pokémon",
   "Item clause: no duplicate held items",
   "Team lock: You may not switch teams once a streak is ongoing",
   "Frontier banlist: no restricted legendaries or mythicals",
   "HP, PP, and status carry between rooms — fainted stay fainted",
   "Losing (or drawing) any battle ends the run"
  ],
  "mechanics": [
   ""
  ],
  "landmarks": [
   "Winning against more difficult trainers gets the team healed",
   "14 rooms per trip; streak counts rooms cleared",
   "Pike Queen Lucy at room 28 (Silver)",
   "Lucy again at room 140 (Gold), then every 56 rooms"
  ],
  "resources": [
   {
    "label": "Damage calculator",
    "url": "https://eisencalc.com"
   },
   {
    "label": "Lookup tool",
    "url": "https://lookup.eisencalc.com"
   }
  ]
 }
];

export const BFSampleTeams: { [formatid: string]: { name: string, by: string, team: string, mons: string[] }[] } = {
 "gen8battletowersingles": [
  {
   "name": "Specs Dragapult balance",
   "by": "Placeholder",
   "team": "Dragapult @ Choice Specs\nAbility: Infiltrator\nLevel: 50\nEVs: 4 HP / 252 SpA / 252 Spe\nTimid Nature\n- Shadow Ball\n- Draco Meteor\n- Flamethrower\n- Thunderbolt\n\nFerrothorn @ Leftovers\nAbility: Iron Barbs\nLevel: 50\nEVs: 252 HP / 4 Atk / 252 SpD\nCareful Nature\n- Gyro Ball\n- Power Whip\n- Leech Seed\n- Protect\n\nPorygon2 @ Eviolite\nAbility: Trace\nLevel: 50\nEVs: 252 HP / 4 Def / 252 SpD\nCalm Nature\n- Recover\n- Ice Beam\n- Thunderbolt\n- Toxic",
   "mons": [
    "Dragapult",
    "Ferrothorn",
    "Porygon2"
   ]
  }
 ]
};

export const BFDexTiers: { [formatid: string]: [string, string][] } = {"gen9ebadoubles": [["header", "Staples"], ["pokemon", "annihilape"], ["pokemon", "archaludon"], ["pokemon", "basculegion"], ["pokemon", "chiyu"], ["pokemon", "chienpao"], ["pokemon", "deoxysattack"], ["pokemon", "diancie"], ["pokemon", "dragapult"], ["pokemon", "dragonite"], ["pokemon", "fluttermane"], ["pokemon", "gholdengo"], ["pokemon", "illumise"], ["pokemon", "incineroar"], ["pokemon", "indeedeef"], ["pokemon", "ironhands"], ["pokemon", "kingambit"], ["pokemon", "kyuremblack"], ["pokemon", "landorus"], ["pokemon", "landorustherian"], ["pokemon", "ogerponhearthflame"], ["pokemon", "ogerponwellspring"], ["pokemon", "pelipper"], ["pokemon", "ragingbolt"], ["pokemon", "rillaboom"], ["pokemon", "sinistcha"], ["pokemon", "sinistchamasterpiece"], ["pokemon", "sneasler"], ["pokemon", "tinglu"], ["pokemon", "torkoal"], ["pokemon", "ursaluna"], ["pokemon", "ursalunabloodmoon"], ["pokemon", "urshifu"], ["pokemon", "urshifurapidstrike"], ["pokemon", "whimsicott"], ["header", "Viable"], ["pokemon", "araquanid"], ["pokemon", "arcaninehisui"], ["pokemon", "armarouge"], ["pokemon", "azumarill"], ["pokemon", "basculegionf"], ["pokemon", "baxcalibur"], ["pokemon", "bellibolt"], ["pokemon", "bronzong"], ["pokemon", "brutebonnet"], ["pokemon", "ceruledge"], ["pokemon", "clefairy"], ["pokemon", "comfey"], ["pokemon", "conkeldurr"], ["pokemon", "copperajah"], ["pokemon", "corviknight"], ["pokemon", "cresselia"], ["pokemon", "dondozo"], ["pokemon", "drifblim"], ["pokemon", "dusclops"], ["pokemon", "electabuzz"], ["pokemon", "enamorus"], ["pokemon", "enamorustherian"], ["pokemon", "entei"], ["pokemon", "excadrill"], ["pokemon", "farigiraf"], ["pokemon", "gallade"], ["pokemon", "garchomp"], ["pokemon", "gardevoir"], ["pokemon", "garganacl"], ["pokemon", "gastrodon"], ["pokemon", "gengar"], ["pokemon", "glastrier"], ["pokemon", "glimmora"], ["pokemon", "goodrahisui"], ["pokemon", "gougingfire"], ["pokemon", "greattusk"], ["pokemon", "grimmsnarl"], ["pokemon", "gyarados"], ["pokemon", "hariyama"], ["pokemon", "hatterene"], ["pokemon", "heatran"], ["pokemon", "hoopaunbound"], ["pokemon", "hydrapple"], ["pokemon", "hydreigon"], ["pokemon", "indeedee"], ["pokemon", "ironboulder"], ["pokemon", "ironbundle"], ["pokemon", "ironcrown"], ["pokemon", "ironjugulis"], ["pokemon", "ironleaves"], ["pokemon", "ironmoth"], ["pokemon", "irontreads"], ["pokemon", "ironvaliant"], ["pokemon", "jirachi"], ["pokemon", "keldeo"], ["pokemon", "keldeoresolute"], ["pokemon", "kilowattrel"], ["pokemon", "kommoo"], ["pokemon", "kyurem"], ["pokemon", "latias"], ["pokemon", "latios"], ["pokemon", "lilliganthisui"], ["pokemon", "lokix"], ["pokemon", "ludicolo"], ["pokemon", "magmar"], ["pokemon", "mamoswine"], ["pokemon", "manaphy"], ["pokemon", "maushold"], ["pokemon", "mausholdfour"], ["pokemon", "meowscarada"], ["pokemon", "metagross"], ["pokemon", "mew"], ["pokemon", "milotic"], ["pokemon", "mimikyu"], ["pokemon", "mudsdale"], ["pokemon", "mukalola"], ["pokemon", "murkrow"], ["pokemon", "necrozma"], ["pokemon", "ninetalesalola"], ["pokemon", "ogerpon"], ["pokemon", "ogerponcornerstone"], ["pokemon", "okidogi"], ["pokemon", "oranguru"], ["pokemon", "palafin"], ["pokemon", "pecharunt"], ["pokemon", "politoed"], ["pokemon", "porygon2"], ["pokemon", "primarina"], ["pokemon", "raikou"], ["pokemon", "regidrago"], ["pokemon", "reuniclus"], ["pokemon", "rhyperior"], ["pokemon", "ribombee"], ["pokemon", "roaringmoon"], ["pokemon", "rotomwash"], ["pokemon", "salamence"], ["pokemon", "sandyshocks"], ["pokemon", "scizor"], ["pokemon", "screamtail"], ["pokemon", "shayminsky"], ["pokemon", "skeledirge"], ["pokemon", "smeargle"], ["pokemon", "snorlax"], ["pokemon", "spectrier"], ["pokemon", "spiritomb"], ["pokemon", "staraptor"], ["pokemon", "suicune"], ["pokemon", "sylveon"], ["pokemon", "talonflame"], ["pokemon", "tatsugiri"], ["pokemon", "tatsugiridroopy"], ["pokemon", "tatsugiristretchy"], ["pokemon", "thundurus"], ["pokemon", "thundurustherian"], ["pokemon", "tinkaton"], ["pokemon", "tornadus"], ["pokemon", "tornadustherian"], ["pokemon", "tsareena"], ["pokemon", "typhlosion"], ["pokemon", "typhlosionhisui"], ["pokemon", "tyranitar"], ["pokemon", "vikavolt"], ["pokemon", "volcanion"], ["pokemon", "volcarona"], ["pokemon", "walkingwake"], ["pokemon", "weezing"], ["pokemon", "weezinggalar"], ["pokemon", "zapdos"], ["pokemon", "zapdosgalar"], ["pokemon", "zoroarkhisui"], ["header", "Cooking"], ["pokemon", "alcremie"], ["pokemon", "alomomola"], ["pokemon", "altaria"], ["pokemon", "ambipom"], ["pokemon", "amoonguss"], ["pokemon", "ampharos"], ["pokemon", "appletun"], ["pokemon", "arbok"], ["pokemon", "arboliva"], ["pokemon", "arcanine"], ["pokemon", "ariados"], ["pokemon", "articuno"], ["pokemon", "articunogalar"], ["pokemon", "avalugg"], ["pokemon", "avalugghisui"], ["pokemon", "azelf"], ["pokemon", "banette"], ["pokemon", "barraskewda"], ["pokemon", "bastiodon"], ["pokemon", "beartic"], ["pokemon", "bellossom"], ["pokemon", "bisharp"], ["pokemon", "blastoise"], ["pokemon", "blaziken"], ["pokemon", "blissey"], ["pokemon", "bombirdier"], ["pokemon", "brambleghast"], ["pokemon", "braviary"], ["pokemon", "braviaryhisui"], ["pokemon", "breloom"], ["pokemon", "cacturne"], ["pokemon", "calyrex"], ["pokemon", "camerupt"], ["pokemon", "carbink"], ["pokemon", "carkol"], ["pokemon", "cetitan"], ["pokemon", "chandelure"], ["pokemon", "chansey"], ["pokemon", "charizard"], ["pokemon", "charjabug"], ["pokemon", "chesnaught"], ["pokemon", "chimecho"], ["pokemon", "cinccino"], ["pokemon", "cinderace"], ["pokemon", "clawitzer"], ["pokemon", "clefable"], ["pokemon", "clodsire"], ["pokemon", "cloyster"], ["pokemon", "coalossal"], ["pokemon", "cobalion"], ["pokemon", "crabominable"], ["pokemon", "cramorant"], ["pokemon", "crawdaunt"], ["pokemon", "cryogonal"], ["pokemon", "cyclizar"], ["pokemon", "dachsbun"], ["pokemon", "darkrai"], ["pokemon", "decidueye"], ["pokemon", "decidueyehisui"], ["pokemon", "dedenne"], ["pokemon", "delibird"], ["pokemon", "delphox"], ["pokemon", "deoxys"], ["pokemon", "deoxysdefense"], ["pokemon", "deoxysspeed"], ["pokemon", "dewgong"], ["pokemon", "ditto"], ["pokemon", "dodrio"], ["pokemon", "drednaw"], ["pokemon", "dudunsparce"], ["pokemon", "dudunsparcethreesegment"], ["pokemon", "dugtrio"], ["pokemon", "dugtrioalola"], ["pokemon", "dunsparce"], ["pokemon", "duraludon"], ["pokemon", "dusknoir"], ["pokemon", "eelektross"], ["pokemon", "eiscue"], ["pokemon", "electivire"], ["pokemon", "electrode"], ["pokemon", "electrodehisui"], ["pokemon", "emboar"], ["pokemon", "empoleon"], ["pokemon", "espathra"], ["pokemon", "espeon"], ["pokemon", "exeggutor"], ["pokemon", "exeggutoralola"], ["pokemon", "falinks"], ["pokemon", "feraligatr"], ["pokemon", "fezandipiti"], ["pokemon", "flapple"], ["pokemon", "flareon"], ["pokemon", "florges"], ["pokemon", "flygon"], ["pokemon", "forretress"], ["pokemon", "froslass"], ["pokemon", "frosmoth"], ["pokemon", "galvantula"], ["pokemon", "girafarig"], ["pokemon", "glaceon"], ["pokemon", "glalie"], ["pokemon", "gligar"], ["pokemon", "gogoat"], ["pokemon", "golduck"], ["pokemon", "golem"], ["pokemon", "golemalola"], ["pokemon", "golurk"], ["pokemon", "goodra"], ["pokemon", "gothitelle"], ["pokemon", "grafaiai"], ["pokemon", "granbull"], ["pokemon", "greedent"], ["pokemon", "greninja"], ["pokemon", "greninjabond"], ["pokemon", "grumpig"], ["pokemon", "gumshoos"], ["pokemon", "gurdurr"], ["pokemon", "hawlucha"], ["pokemon", "haxorus"], ["pokemon", "heracross"], ["pokemon", "hippowdon"], ["pokemon", "hitmonchan"], ["pokemon", "hitmonlee"], ["pokemon", "hitmontop"], ["pokemon", "honchkrow"], ["pokemon", "hoopa"], ["pokemon", "houndoom"], ["pokemon", "houndstone"], ["pokemon", "hypno"], ["pokemon", "infernape"], ["pokemon", "inteleon"], ["pokemon", "ironthorns"], ["pokemon", "jolteon"], ["pokemon", "jumpluff"], ["pokemon", "kingdra"], ["pokemon", "kleavor"], ["pokemon", "klefki"], ["pokemon", "komala"], ["pokemon", "krookodile"], ["pokemon", "lanturn"], ["pokemon", "lapras"], ["pokemon", "leafeon"], ["pokemon", "leavanny"], ["pokemon", "lilligant"], ["pokemon", "lucario"], ["pokemon", "lumineon"], ["pokemon", "luvdisc"], ["pokemon", "luxray"], ["pokemon", "lycanroc"], ["pokemon", "lycanrocdusk"], ["pokemon", "lycanrocmidnight"], ["pokemon", "mabosstiff"], ["pokemon", "magcargo"], ["pokemon", "magmortar"], ["pokemon", "magneton"], ["pokemon", "magnezone"], ["pokemon", "malamar"], ["pokemon", "mandibuzz"], ["pokemon", "masquerain"], ["pokemon", "medicham"], ["pokemon", "meganium"], ["pokemon", "meloetta"], ["pokemon", "meowstic"], ["pokemon", "meowsticf"], ["pokemon", "mesprit"], ["pokemon", "mienshao"], ["pokemon", "mightyena"], ["pokemon", "minior"], ["pokemon", "misdreavus"], ["pokemon", "mismagius"], ["pokemon", "moltres"], ["pokemon", "moltresgalar"], ["pokemon", "morpeko"], ["pokemon", "muk"], ["pokemon", "munchlax"], ["pokemon", "munkidori"], ["pokemon", "ninetales"], ["pokemon", "noctowl"], ["pokemon", "noivern"], ["pokemon", "oinkologne"], ["pokemon", "oinkolognef"], ["pokemon", "oricorio"], ["pokemon", "oricoriopau"], ["pokemon", "oricoriopompom"], ["pokemon", "oricoriosensu"], ["pokemon", "orthworm"], ["pokemon", "overqwil"], ["pokemon", "pachirisu"], ["pokemon", "palossand"], ["pokemon", "passimian"], ["pokemon", "pawmot"], ["pokemon", "persian"], ["pokemon", "persianalola"], ["pokemon", "pikachu"], ["pokemon", "piloswine"], ["pokemon", "pincurchin"], ["pokemon", "polteageist"], ["pokemon", "polteageistantique"], ["pokemon", "porygonz"], ["pokemon", "primeape"], ["pokemon", "probopass"], ["pokemon", "pyroar"], ["pokemon", "quagsire"], ["pokemon", "quaquaval"], ["pokemon", "qwilfish"], ["pokemon", "qwilfishhisui"], ["pokemon", "raichu"], ["pokemon", "raichualola"], ["pokemon", "rampardos"], ["pokemon", "regice"], ["pokemon", "regieleki"], ["pokemon", "regigigas"], ["pokemon", "regirock"], ["pokemon", "registeel"], ["pokemon", "revavroom"], ["pokemon", "rhydon"], ["pokemon", "rotom"], ["pokemon", "rotomfan"], ["pokemon", "rotomfrost"], ["pokemon", "rotomheat"], ["pokemon", "rotommow"], ["pokemon", "salazzle"], ["pokemon", "samurott"], ["pokemon", "samurotthisui"], ["pokemon", "sandaconda"], ["pokemon", "sandslash"], ["pokemon", "sandslashalola"], ["pokemon", "sawsbuck"], ["pokemon", "sceptile"], ["pokemon", "scovillain"], ["pokemon", "scyther"], ["pokemon", "serperior"], ["pokemon", "shaymin"], ["pokemon", "skarmory"], ["pokemon", "skuntank"], ["pokemon", "slitherwing"], ["pokemon", "slowbro"], ["pokemon", "slowbrogalar"], ["pokemon", "slowking"], ["pokemon", "slowkinggalar"], ["pokemon", "slowpoke"], ["pokemon", "slowpokegalar"], ["pokemon", "squawkabilly"], ["pokemon", "squawkabillyblue"], ["pokemon", "squawkabillywhite"], ["pokemon", "squawkabillyyellow"], ["pokemon", "stantler"], ["pokemon", "stonjourner"], ["pokemon", "sudowoodo"], ["pokemon", "sunflora"], ["pokemon", "swalot"], ["pokemon", "swampert"], ["pokemon", "tauros"], ["pokemon", "taurospaldeaaqua"], ["pokemon", "taurospaldeablaze"], ["pokemon", "taurospaldeacombat"], ["pokemon", "tentacruel"], ["pokemon", "terrakion"], ["pokemon", "toedscruel"], ["pokemon", "torracat"], ["pokemon", "torterra"], ["pokemon", "toucannon"], ["pokemon", "toxapex"], ["pokemon", "toxicroak"], ["pokemon", "toxtricity"], ["pokemon", "toxtricitylowkey"], ["pokemon", "trevenant"], ["pokemon", "tropius"], ["pokemon", "umbreon"], ["pokemon", "ursaring"], ["pokemon", "uxie"], ["pokemon", "vaporeon"], ["pokemon", "veluza"], ["pokemon", "venomoth"], ["pokemon", "venusaur"], ["pokemon", "vespiquen"], ["pokemon", "victreebel"], ["pokemon", "vigoroth"], ["pokemon", "vileplume"], ["pokemon", "virizion"], ["pokemon", "vivillon"], ["pokemon", "vivillonfancy"], ["pokemon", "vivillonpokeball"], ["pokemon", "volbeat"], ["pokemon", "whiscash"], ["pokemon", "wigglytuff"], ["pokemon", "wochien"], ["pokemon", "wugtrio"], ["pokemon", "wyrdeer"], ["pokemon", "yanmega"], ["pokemon", "zangoose"], ["pokemon", "zarude"], ["pokemon", "zarudedada"], ["pokemon", "zebstrika"], ["pokemon", "zoroark"], ["header", "Probably Unviable"], ["pokemon", "abomasnow"], ["pokemon", "aipom"], ["pokemon", "applin"], ["pokemon", "arctibax"], ["pokemon", "arrokuda"], ["pokemon", "axew"], ["pokemon", "azurill"], ["pokemon", "bagon"], ["pokemon", "barboach"], ["pokemon", "basculin"], ["pokemon", "basculinbluestriped"], ["pokemon", "basculinwhitestriped"], ["pokemon", "bayleef"], ["pokemon", "beldum"], ["pokemon", "bellsprout"], ["pokemon", "bergmite"], ["pokemon", "blitzle"], ["pokemon", "bonsly"], ["pokemon", "bounsweet"], ["pokemon", "braixen"], ["pokemon", "bramblin"], ["pokemon", "brionne"], ["pokemon", "bronzor"], ["pokemon", "bruxish"], ["pokemon", "buizel"], ["pokemon", "bulbasaur"], ["pokemon", "cacnea"], ["pokemon", "capsakid"], ["pokemon", "cetoddle"], ["pokemon", "charcadet"], ["pokemon", "charmander"], ["pokemon", "charmeleon"], ["pokemon", "chespin"], ["pokemon", "chewtle"], ["pokemon", "chikorita"], ["pokemon", "chimchar"], ["pokemon", "chinchou"], ["pokemon", "chingling"], ["pokemon", "clauncher"], ["pokemon", "cleffa"], ["pokemon", "combee"], ["pokemon", "combusken"], ["pokemon", "corphish"], ["pokemon", "corvisquire"], ["pokemon", "cosmoem"], ["pokemon", "cosmog"], ["pokemon", "cottonee"], ["pokemon", "crabrawler"], ["pokemon", "cranidos"], ["pokemon", "croagunk"], ["pokemon", "crocalor"], ["pokemon", "croconaw"], ["pokemon", "cubchoo"], ["pokemon", "cufant"], ["pokemon", "cutiefly"], ["pokemon", "cyndaquil"], ["pokemon", "dartrix"], ["pokemon", "deerling"], ["pokemon", "deino"], ["pokemon", "dewott"], ["pokemon", "dewpider"], ["pokemon", "diglett"], ["pokemon", "diglettalola"], ["pokemon", "dipplin"], ["pokemon", "doduo"], ["pokemon", "dolliv"], ["pokemon", "donphan"], ["pokemon", "dragalge"], ["pokemon", "dragonair"], ["pokemon", "drakloak"], ["pokemon", "dratini"], ["pokemon", "dreepy"], ["pokemon", "drifloon"], ["pokemon", "drilbur"], ["pokemon", "drizzile"], ["pokemon", "drowzee"], ["pokemon", "ducklett"], ["pokemon", "duosion"], ["pokemon", "duskull"], ["pokemon", "eelektrik"], ["pokemon", "eevee"], ["pokemon", "ekans"], ["pokemon", "elekid"], ["pokemon", "espurr"], ["pokemon", "exeggcute"], ["pokemon", "feebas"], ["pokemon", "fennekin"], ["pokemon", "fidough"], ["pokemon", "finizen"], ["pokemon", "finneon"], ["pokemon", "flaaffy"], ["pokemon", "flabebe"], ["pokemon", "flamigo"], ["pokemon", "fletchinder"], ["pokemon", "fletchling"], ["pokemon", "flittle"], ["pokemon", "floatzel"], ["pokemon", "floette"], ["pokemon", "floragato"], ["pokemon", "fomantis"], ["pokemon", "foongus"], ["pokemon", "fraxure"], ["pokemon", "frigibax"], ["pokemon", "froakie"], ["pokemon", "frogadier"], ["pokemon", "fuecoco"], ["pokemon", "furret"], ["pokemon", "gabite"], ["pokemon", "gastly"], ["pokemon", "geodude"], ["pokemon", "geodudealola"], ["pokemon", "gible"], ["pokemon", "gimmighoul"], ["pokemon", "gimmighoulroaming"], ["pokemon", "glimmet"], ["pokemon", "gliscor"], ["pokemon", "gloom"], ["pokemon", "golett"], ["pokemon", "goomy"], ["pokemon", "gothita"], ["pokemon", "gothorita"], ["pokemon", "graveler"], ["pokemon", "graveleralola"], ["pokemon", "greavard"], ["pokemon", "grimer"], ["pokemon", "grimeralola"], ["pokemon", "grookey"], ["pokemon", "grotle"], ["pokemon", "grovyle"], ["pokemon", "growlithe"], ["pokemon", "growlithehisui"], ["pokemon", "grubbin"], ["pokemon", "gulpin"], ["pokemon", "hakamoo"], ["pokemon", "happiny"], ["pokemon", "hatenna"], ["pokemon", "hattrem"], ["pokemon", "haunter"], ["pokemon", "hippopotas"], ["pokemon", "hoothoot"], ["pokemon", "hoppip"], ["pokemon", "horsea"], ["pokemon", "houndour"], ["pokemon", "igglybuff"], ["pokemon", "impidimp"], ["pokemon", "inkay"], ["pokemon", "ivysaur"], ["pokemon", "jangmoo"], ["pokemon", "jigglypuff"], ["pokemon", "joltik"], ["pokemon", "kirlia"], ["pokemon", "klawf"], ["pokemon", "koffing"], ["pokemon", "kricketot"], ["pokemon", "kricketune"], ["pokemon", "krokorok"], ["pokemon", "kubfu"], ["pokemon", "lampent"], ["pokemon", "larvesta"], ["pokemon", "larvitar"], ["pokemon", "lechonk"], ["pokemon", "litleo"], ["pokemon", "litten"], ["pokemon", "litwick"], ["pokemon", "lombre"], ["pokemon", "lotad"], ["pokemon", "lurantis"], ["pokemon", "luxio"], ["pokemon", "magby"], ["pokemon", "magikarp"], ["pokemon", "magnemite"], ["pokemon", "makuhita"], ["pokemon", "mankey"], ["pokemon", "mareanie"], ["pokemon", "mareep"], ["pokemon", "marill"], ["pokemon", "marshtomp"], ["pokemon", "maschiff"], ["pokemon", "meditite"], ["pokemon", "meowth"], ["pokemon", "meowthalola"], ["pokemon", "meowthgalar"], ["pokemon", "metang"], ["pokemon", "mienfoo"], ["pokemon", "milcery"], ["pokemon", "minccino"], ["pokemon", "minun"], ["pokemon", "monferno"], ["pokemon", "morgrem"], ["pokemon", "mudbray"], ["pokemon", "mudkip"], ["pokemon", "nacli"], ["pokemon", "naclstack"], ["pokemon", "noibat"], ["pokemon", "nosepass"], ["pokemon", "numel"], ["pokemon", "nuzleaf"], ["pokemon", "nymble"], ["pokemon", "oddish"], ["pokemon", "oshawott"], ["pokemon", "pawmi"], ["pokemon", "pawmo"], ["pokemon", "pawniard"], ["pokemon", "perrserker"], ["pokemon", "petilil"], ["pokemon", "phanpy"], ["pokemon", "phantump"], ["pokemon", "phione"], ["pokemon", "pichu"], ["pokemon", "pignite"], ["pokemon", "pikachualola"], ["pokemon", "pikachuhoenn"], ["pokemon", "pikachukalos"], ["pokemon", "pikachuoriginal"], ["pokemon", "pikachupartner"], ["pokemon", "pikachusinnoh"], ["pokemon", "pikachuunova"], ["pokemon", "pikachuworld"], ["pokemon", "pikipek"], ["pokemon", "pineco"], ["pokemon", "piplup"], ["pokemon", "plusle"], ["pokemon", "poliwag"], ["pokemon", "poliwhirl"], ["pokemon", "poliwrath"], ["pokemon", "poltchageist"], ["pokemon", "poltchageistartisan"], ["pokemon", "poochyena"], ["pokemon", "popplio"], ["pokemon", "porygon"], ["pokemon", "prinplup"], ["pokemon", "psyduck"], ["pokemon", "pupitar"], ["pokemon", "quaxly"], ["pokemon", "quaxwell"], ["pokemon", "quilava"], ["pokemon", "quilladin"], ["pokemon", "raboot"], ["pokemon", "rabsca"], ["pokemon", "ralts"], ["pokemon", "rellor"], ["pokemon", "rhyhorn"], ["pokemon", "riolu"], ["pokemon", "rockruff"], ["pokemon", "rockruffdusk"], ["pokemon", "rolycoly"], ["pokemon", "rookidee"], ["pokemon", "rowlet"], ["pokemon", "rufflet"], ["pokemon", "sableye"], ["pokemon", "salandit"], ["pokemon", "sandile"], ["pokemon", "sandshrew"], ["pokemon", "sandshrewalola"], ["pokemon", "sandygast"], ["pokemon", "scatterbug"], ["pokemon", "scorbunny"], ["pokemon", "scrafty"], ["pokemon", "scraggy"], ["pokemon", "seadra"], ["pokemon", "seedot"], ["pokemon", "seel"], ["pokemon", "sentret"], ["pokemon", "servine"], ["pokemon", "seviper"], ["pokemon", "sewaddle"], ["pokemon", "shelgon"], ["pokemon", "shellder"], ["pokemon", "shellos"], ["pokemon", "shieldon"], ["pokemon", "shiftry"], ["pokemon", "shinx"], ["pokemon", "shroodle"], ["pokemon", "shroomish"], ["pokemon", "shuppet"], ["pokemon", "silicobra"], ["pokemon", "sinistea"], ["pokemon", "sinisteaantique"], ["pokemon", "skiddo"], ["pokemon", "skiploom"], ["pokemon", "skrelp"], ["pokemon", "skwovet"], ["pokemon", "slaking"], ["pokemon", "slakoth"], ["pokemon", "sliggoo"], ["pokemon", "sliggoohisui"], ["pokemon", "slugma"], ["pokemon", "smoliv"], ["pokemon", "sneasel"], ["pokemon", "sneaselhisui"], ["pokemon", "snivy"], ["pokemon", "snom"], ["pokemon", "snorunt"], ["pokemon", "snover"], ["pokemon", "snubbull"], ["pokemon", "sobble"], ["pokemon", "solosis"], ["pokemon", "spewpa"], ["pokemon", "spidops"], ["pokemon", "spinarak"], ["pokemon", "spoink"], ["pokemon", "sprigatito"], ["pokemon", "squirtle"], ["pokemon", "staravia"], ["pokemon", "starly"], ["pokemon", "steenee"], ["pokemon", "stunky"], ["pokemon", "sunkern"], ["pokemon", "surskit"], ["pokemon", "swablu"], ["pokemon", "swadloon"], ["pokemon", "swanna"], ["pokemon", "swinub"], ["pokemon", "tadbulb"], ["pokemon", "tandemaus"], ["pokemon", "tarountula"], ["pokemon", "teddiursa"], ["pokemon", "tentacool"], ["pokemon", "tepig"], ["pokemon", "thwackey"], ["pokemon", "timburr"], ["pokemon", "tinkatink"], ["pokemon", "tinkatuff"], ["pokemon", "toedscool"], ["pokemon", "torchic"], ["pokemon", "totodile"], ["pokemon", "toxel"], ["pokemon", "trapinch"], ["pokemon", "treecko"], ["pokemon", "trumbeak"], ["pokemon", "turtwig"], ["pokemon", "tynamo"], ["pokemon", "tyrogue"], ["pokemon", "varoom"], ["pokemon", "venonat"], ["pokemon", "vibrava"], ["pokemon", "voltorb"], ["pokemon", "voltorbhisui"], ["pokemon", "vullaby"], ["pokemon", "vulpix"], ["pokemon", "vulpixalola"], ["pokemon", "wartortle"], ["pokemon", "wattrel"], ["pokemon", "weavile"], ["pokemon", "weepinbell"], ["pokemon", "wiglett"], ["pokemon", "wingull"], ["pokemon", "wooper"], ["pokemon", "wooperpaldea"], ["pokemon", "yanma"], ["pokemon", "yungoos"], ["pokemon", "zorua"], ["pokemon", "zoruahisui"], ["pokemon", "zweilous"]], "gen9eisenchampsmcdoubles": [["header", "Staples"], ["pokemon", "aerodactyl"], ["pokemon", "archaludon"], ["pokemon", "basculegion"], ["pokemon", "charizard"], ["pokemon", "delphox"], ["pokemon", "dragonite"], ["pokemon", "farigiraf"], ["pokemon", "floetteeternal"], ["pokemon", "froslass"], ["pokemon", "garchomp"], ["pokemon", "gardevoir"], ["pokemon", "gengar"], ["pokemon", "gholdengo"], ["pokemon", "incineroar"], ["pokemon", "indeedeef"], ["pokemon", "kingambit"], ["pokemon", "milotic"], ["pokemon", "pelipper"], ["pokemon", "rillaboom"], ["pokemon", "salamence"], ["pokemon", "sinistcha"], ["pokemon", "sinistchamasterpiece"], ["pokemon", "sneasler"], ["pokemon", "staraptor"], ["pokemon", "swampert"], ["pokemon", "sylveon"], ["pokemon", "torkoal"], ["pokemon", "venusaur"], ["pokemon", "whimsicott"], ["header", "Proven"], ["pokemon", "absol"], ["pokemon", "aegislash"], ["pokemon", "annihilape"], ["pokemon", "araquanid"], ["pokemon", "arcaninehisui"], ["pokemon", "armarouge"], ["pokemon", "azumarill"], ["pokemon", "baxcalibur"], ["pokemon", "blastoise"], ["pokemon", "blaziken"], ["pokemon", "camerupt"], ["pokemon", "ceruledge"], ["pokemon", "chandelure"], ["pokemon", "cinderace"], ["pokemon", "clefable"], ["pokemon", "conkeldurr"], ["pokemon", "corviknight"], ["pokemon", "crabominable"], ["pokemon", "dragapult"], ["pokemon", "excadrill"], ["pokemon", "feraligatr"], ["pokemon", "gallade"], ["pokemon", "glimmora"], ["pokemon", "golisopod"], ["pokemon", "grimmsnarl"], ["pokemon", "gyarados"], ["pokemon", "hatterene"], ["pokemon", "hydreigon"], ["pokemon", "indeedee"], ["pokemon", "kangaskhan"], ["pokemon", "kleavor"], ["pokemon", "kommoo"], ["pokemon", "lopunny"], ["pokemon", "lucario"], ["pokemon", "lycanrocdusk"], ["pokemon", "maushold"], ["pokemon", "mausholdfour"], ["pokemon", "mawile"], ["pokemon", "meowscarada"], ["pokemon", "metagross"], ["pokemon", "mimikyu"], ["pokemon", "ninetalesalola"], ["pokemon", "oranguru"], ["pokemon", "overqwil"], ["pokemon", "palafin"], ["pokemon", "pawmot"], ["pokemon", "persianalola"], ["pokemon", "politoed"], ["pokemon", "primarina"], ["pokemon", "pyroar"], ["pokemon", "raichu"], ["pokemon", "rotomheat"], ["pokemon", "rotommow"], ["pokemon", "rotomwash"], ["pokemon", "sableye"], ["pokemon", "scizor"], ["pokemon", "scovillain"], ["pokemon", "scrafty"], ["pokemon", "serperior"], ["pokemon", "sirfetchd"], ["pokemon", "snorlax"], ["pokemon", "spiritomb"], ["pokemon", "starmie"], ["pokemon", "steelix"], ["pokemon", "talonflame"], ["pokemon", "taurospaldeaaqua"], ["pokemon", "taurospaldeablaze"], ["pokemon", "tinkaton"], ["pokemon", "toxapex"], ["pokemon", "tsareena"], ["pokemon", "typhlosionhisui"], ["pokemon", "tyranitar"], ["pokemon", "vivillon"], ["pokemon", "vivillonfancy"], ["pokemon", "vivillonpokeball"], ["pokemon", "volcarona"], ["pokemon", "weavile"], ["pokemon", "zoroarkhisui"], ["header", "Cooking"], ["pokemon", "abomasnow"], ["pokemon", "aggron"], ["pokemon", "alakazam"], ["pokemon", "alcremie"], ["pokemon", "altaria"], ["pokemon", "ampharos"], ["pokemon", "appletun"], ["pokemon", "arbok"], ["pokemon", "arboliva"], ["pokemon", "arcanine"], ["pokemon", "ariados"], ["pokemon", "aromatisse"], ["pokemon", "audino"], ["pokemon", "aurorus"], ["pokemon", "avalugg"], ["pokemon", "avalugghisui"], ["pokemon", "banette"], ["pokemon", "barbaracle"], ["pokemon", "basculegionf"], ["pokemon", "bastiodon"], ["pokemon", "beartic"], ["pokemon", "beedrill"], ["pokemon", "bellibolt"], ["pokemon", "castform"], ["pokemon", "chesnaught"], ["pokemon", "chimecho"], ["pokemon", "clawitzer"], ["pokemon", "cofagrigus"], ["pokemon", "decidueye"], ["pokemon", "decidueyehisui"], ["pokemon", "dedenne"], ["pokemon", "diggersby"], ["pokemon", "ditto"], ["pokemon", "dragalge"], ["pokemon", "drampa"], ["pokemon", "eelektross"], ["pokemon", "emboar"], ["pokemon", "emolga"], ["pokemon", "empoleon"], ["pokemon", "espathra"], ["pokemon", "espeon"], ["pokemon", "falinks"], ["pokemon", "farfetchd"], ["pokemon", "flapple"], ["pokemon", "flareon"], ["pokemon", "florges"], ["pokemon", "forretress"], ["pokemon", "furfrou"], ["pokemon", "garbodor"], ["pokemon", "garganacl"], ["pokemon", "glaceon"], ["pokemon", "glalie"], ["pokemon", "gliscor"], ["pokemon", "gogoat"], ["pokemon", "golurk"], ["pokemon", "goodra"], ["pokemon", "goodrahisui"], ["pokemon", "gourgeist"], ["pokemon", "gourgeistlarge"], ["pokemon", "gourgeistsmall"], ["pokemon", "gourgeistsuper"], ["pokemon", "grapploct"], ["pokemon", "greninja"], ["pokemon", "hawlucha"], ["pokemon", "heliolisk"], ["pokemon", "heracross"], ["pokemon", "hippowdon"], ["pokemon", "houndoom"], ["pokemon", "houndstone"], ["pokemon", "hydrapple"], ["pokemon", "infernape"], ["pokemon", "inteleon"], ["pokemon", "jolteon"], ["pokemon", "klefki"], ["pokemon", "krookodile"], ["pokemon", "leafeon"], ["pokemon", "liepard"], ["pokemon", "luxray"], ["pokemon", "lycanroc"], ["pokemon", "lycanrocmidnight"], ["pokemon", "mabosstiff"], ["pokemon", "machamp"], ["pokemon", "malamar"], ["pokemon", "mamoswine"], ["pokemon", "manectric"], ["pokemon", "medicham"], ["pokemon", "meganium"], ["pokemon", "meowstic"], ["pokemon", "meowsticf"], ["pokemon", "morpeko"], ["pokemon", "mrmime"], ["pokemon", "mrrime"], ["pokemon", "mudsdale"], ["pokemon", "musharna"], ["pokemon", "ninetales"], ["pokemon", "noivern"], ["pokemon", "orthworm"], ["pokemon", "pangoro"], ["pokemon", "passimian"], ["pokemon", "perrserker"], ["pokemon", "persian"], ["pokemon", "pidgeot"], ["pokemon", "pikachu"], ["pokemon", "pincurchin"], ["pokemon", "pinsir"], ["pokemon", "polteageist"], ["pokemon", "polteageistantique"], ["pokemon", "quaquaval"], ["pokemon", "qwilfish"], ["pokemon", "raichualola"], ["pokemon", "rampardos"], ["pokemon", "reuniclus"], ["pokemon", "rhyperior"], ["pokemon", "roserade"], ["pokemon", "rotom"], ["pokemon", "rotomfan"], ["pokemon", "rotomfrost"], ["pokemon", "runerigus"], ["pokemon", "salazzle"], ["pokemon", "samurott"], ["pokemon", "samurotthisui"], ["pokemon", "sandaconda"], ["pokemon", "sceptile"], ["pokemon", "scolipede"], ["pokemon", "sharpedo"], ["pokemon", "simipour"], ["pokemon", "simisage"], ["pokemon", "simisear"], ["pokemon", "skarmory"], ["pokemon", "skeledirge"], ["pokemon", "slowbro"], ["pokemon", "slowbrogalar"], ["pokemon", "slowking"], ["pokemon", "slowkinggalar"], ["pokemon", "slurpuff"], ["pokemon", "squawkabilly"], ["pokemon", "squawkabillyblue"], ["pokemon", "squawkabillywhite"], ["pokemon", "squawkabillyyellow"], ["pokemon", "stunfisk"], ["pokemon", "stunfiskgalar"], ["pokemon", "swalot"], ["pokemon", "tauros"], ["pokemon", "taurospaldeacombat"], ["pokemon", "thievul"], ["pokemon", "torterra"], ["pokemon", "toucannon"], ["pokemon", "toxicroak"], ["pokemon", "toxtricity"], ["pokemon", "toxtricitylowkey"], ["pokemon", "trevenant"], ["pokemon", "typhlosion"], ["pokemon", "tyrantrum"], ["pokemon", "umbreon"], ["pokemon", "vanilluxe"], ["pokemon", "vaporeon"], ["pokemon", "victreebel"], ["pokemon", "vileplume"], ["pokemon", "watchog"], ["pokemon", "wigglytuff"], ["pokemon", "wyrdeer"], ["pokemon", "zoroark"]]};

export const BFDexBanned: { [formatid: string]: string[] } = {"gen9ebadoubles": ["arceus", "arceusbug", "arceusdark", "arceusdragon", "arceuselectric", "arceusfairy", "arceusfighting", "arceusfire", "arceusflying", "arceusghost", "arceusgrass", "arceusground", "arceusice", "arceuspoison", "arceuspsychic", "arceusrock", "arceussteel", "arceuswater", "calyrexice", "calyrexshadow", "dialga", "dialgaorigin", "eternatus", "giratina", "giratinaorigin", "groudon", "hooh", "koraidon", "kyogre", "kyuremwhite", "lugia", "lunala", "magearna", "magearnaoriginal", "mewtwo", "miraidon", "necrozmadawnwings", "necrozmaduskmane", "palafinhero", "palkia", "palkiaorigin", "rayquaza", "reshiram", "solgaleo", "terapagos", "terapagosstellar", "terapagosterastal", "zacian", "zaciancrowned", "zamazenta", "zamazentacrowned", "zekrom"]};

export const BFMoveOverrides: { [formatid: string]: { useful: string[], useless: string[] } } = {"gen8bdspbattletowerdoubles": {"useful": ["acidspray"], "useless": []}, "gen9ebadoubles": {"useful": ["acidspray", "afteryou", "assurance", "babydolleyes", "beatup", "bellydrum", "breakingswipe", "bugbite", "burningjealousy", "cottonspore", "crosspoison", "dazzlinggleam", "dualwingbeat", "eerieimpulse", "fakeout", "feint", "finalgambit", "firepledge", "floralhealing", "flyingpress", "forestscurse", "glaciate", "grasspledge", "gravity", "howl", "hyperspacefury", "hyperspacehole", "icywind", "instruct", "irondefense", "jawlock", "jetpunch", "leafblade", "leechlife", "leer", "lowsweep", "magicpowder", "meteorbeam", "mysticalfire", "nightdaze", "paraboliccharge", "phantomforce", "quash", "risingvoltage", "shelter", "simplebeam", "speedswap", "strugglebug", "tailwhip", "takeheart", "thunderfang", "tropkick", "waterpledge", "wildcharge"], "useless": ["agility", "ancientpower", "avalanche", "blazekick", "chillingwater", "circlethrow", "courtchange", "crosschop", "defog", "dragontail", "explosion", "extrasensory", "fireblast", "flamecharge", "fling", "focusblast", "focuspunch", "futuresight", "haze", "healbell", "healingwish", "hex", "honeclaws", "hypnosis", "infestation", "irontail", "lashout", "lavaplume", "magmastorm", "meteormash", "moonlight", "morningsun", "mortalspin", "outrage", "petalblizzard", "psychicnoise", "ragingfury", "rapidspin", "reflecttype", "rest", "roar", "rockpolish", "safeguard", "selfdestruct", "sleeppowder", "sleeptalk", "smackdown", "soak", "sparklingaria", "spikes", "stealthrock", "steelbeam", "stickyweb", "stunspore", "thundercage", "tidyup", "toxicspikes", "trailblaze", "whirlwind", "wish"]}, "gen9ebadoubles6v6": {"useful": ["acidspray", "afteryou", "assurance", "babydolleyes", "beatup", "bellydrum", "breakingswipe", "bugbite", "burningjealousy", "cottonspore", "crosspoison", "dazzlinggleam", "dualwingbeat", "eerieimpulse", "fakeout", "feint", "finalgambit", "firepledge", "floralhealing", "flyingpress", "forestscurse", "glaciate", "grasspledge", "gravity", "howl", "hyperspacefury", "hyperspacehole", "icywind", "instruct", "irondefense", "jawlock", "jetpunch", "leafblade", "leechlife", "leer", "lowsweep", "magicpowder", "meteorbeam", "mysticalfire", "nightdaze", "paraboliccharge", "phantomforce", "quash", "risingvoltage", "shelter", "simplebeam", "speedswap", "strugglebug", "tailwhip", "takeheart", "thunderfang", "tropkick", "waterpledge", "wildcharge"], "useless": ["agility", "ancientpower", "avalanche", "blazekick", "chillingwater", "circlethrow", "courtchange", "crosschop", "defog", "dragontail", "explosion", "extrasensory", "fireblast", "flamecharge", "fling", "focusblast", "focuspunch", "futuresight", "haze", "healbell", "healingwish", "hex", "honeclaws", "hypnosis", "infestation", "irontail", "lashout", "lavaplume", "magmastorm", "meteormash", "moonlight", "morningsun", "mortalspin", "outrage", "petalblizzard", "psychicnoise", "ragingfury", "rapidspin", "reflecttype", "rest", "roar", "rockpolish", "safeguard", "selfdestruct", "sleeppowder", "sleeptalk", "smackdown", "soak", "sparklingaria", "spikes", "stealthrock", "steelbeam", "stickyweb", "stunspore", "thundercage", "tidyup", "toxicspikes", "trailblaze", "whirlwind", "wish"]}};

export const BFChampsLearnsetAdditions: { [speciesid: string]: string[] } = {};
